<template>
  <heading v-if="category.title" tag="h2">{{ category.title }}</heading>
  <DisplayGrid>
    <PdfThumbnail v-for="item in items" :key="item.imgSrc" v-bind="item" />
  </DisplayGrid>
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
interface Props {
  category: CategorySchema;
  mMedias: Map<string, MediaSchema>;
}
const props = defineProps({
  category: null,
  mMedias: null
});

const items = useCategoryPostsThumbnails(props.category, props.mMedias);
</script>
